import { css } from '@emotion/react';
import styled from '@emotion/styled';

import COLORS3 from '../../../styles/emotion/colors3';
import MEDIA_QUERY_V2 from '../../../styles/emotion/mediaQueryV2';
import SPACING from '../../../styles/emotion/spacing';
import ZINDEX from '../../../styles/emotion/zIndex';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${COLORS3.WHITE_100};
  position: relative;
  z-index: ${ZINDEX.bottom};

  ${MEDIA_QUERY_V2.DESKTOP} {
    flex-direction: row;
    height: 100vh;
  }
`;

export const ContentContainer = styled.div`
  flex: 1 1 100%;
  padding: ${SPACING.S16};
  border-bottom: 1px solid ${COLORS3.BLACK_030};

  ${MEDIA_QUERY_V2.DESKTOP} {
    flex: 1 1 40%;
    max-width: 768px;
    border-bottom: none;
    border-right: 1px solid ${COLORS3.BLACK_030};
  }
`;

export const Content = styled.div`
  height: 100%;
  border-radius: 16px;
  overflow: hidden;
`;

export const SectionsContainer = styled.div`
  flex-basis: 100%;
  padding: ${SPACING.MD};
  padding-top: 52px;
  overflow: auto;

  ${MEDIA_QUERY_V2.DESKTOP} {
    flex: 1 1 60%;
    position: relative;
  }
`;

export const SectionsContent = styled.div<{ isHidden: boolean }>`
  max-width: 500px;
  width: 100%;
  margin: 0 auto;
  ${({ isHidden }) => isHidden && `display: none;`}
`;

export const CloseOnboardingBtn = styled.button`
  position: absolute;
  top: ${SPACING.S24};
  right: ${SPACING.S24};
  outline: none;
  border: none;
  background: none;
  padding: 0;
  height: ${SPACING.S16};
  z-index: ${ZINDEX.middle};
`;

export const TempImg = styled.img`
  width: 100%;
`;

export const Row = styled.div<{
  format: string;
  formatMobile?: string;
  gridGap?: string;
  gridGapMobile?: string;
}>`
  display: grid;
  margin-bottom: ${SPACING.S16};
  grid-gap: ${({ gridGapMobile = SPACING.XS }) => gridGapMobile};
  grid-template-columns: ${({ formatMobile = '' }) => formatMobile};
  ${MEDIA_QUERY_V2.EXCLUDE_MOBILE} {
    grid-gap: ${({ gridGap = SPACING.S16 }) => gridGap};
    grid-template-columns: ${({ format }) => format};
  }
`;

export const CloseOnboardingContainer = styled.div`
  ${MEDIA_QUERY_V2.EXCLUDE_DESKTOP} {
    height: 56px;
    display: block;
    position: relative;
    background-color: ${COLORS3.WHITE_100};
  }
`;

export const hidePortalOnMobile = css`
  ${MEDIA_QUERY_V2.MOBILE} {
    ${ContentContainer} {
      display: none;
    }
    ${SectionsContainer} {
      padding-top: ${SPACING.S16};
    }
  }
`;

export const hidePortal = css`
  ${ContentContainer} {
    display: none;
  }
`;
